<template>
  <div class="student-form-container">
    <div class="page-header">
      <div class="breadcrumb">ນັກຮຽນ / <span>{{ isEdit ? 'ແກ້ໄຂຂໍ້ມູນນັກຮຽນ' : 'ລົງທະບຽນນັກຮຽນໃໝ່' }}</span></div>
      <div class="header-content">
        <h1>{{ isEdit ? 'ແກ້ໄຂຂໍ້ມູນນັກຮຽນ' : 'ລົງທະບຽນນັກຮຽນໃໝ່' }}</h1>
        <p>ກະລຸນາປ້ອນຂໍ້ມູນຊີວະປະຫວັດ ແລະ ທີ່ຢູ່ໃຫ້ຄົບຖ້ວນ</p> {{ hasBit('student-new', 1) }}  
      </div>
    </div>

    <form @submit.prevent="handleSubmit">
      <div class="form-layout">
        <!-- ສ່ວນເບື້ອງຊ້າຍ: Profile & ID -->
        <div class="form-sidebar">
          <div class="panel avatar-panel">
            <div class="avatar-wrapper">
              <div class="avatar-view">
                <img :src="studentForm.avatar_base64 || require('@/assets/logo.png')" :class="{ 'is-empty': !studentForm.avatar_base64 }">
                <button v-if="studentForm.avatar_base64" type="button" class="remove-avatar" @click="removeAvatar">×</button>
              </div>
              <label class="upload-label">
                <i class="fas fa-camera"></i> ອັບໂຫຼດຮູບ
                <input type="file" @change="handleFileUpload" accept="image/*" hidden>
              </label>
              <div class="error-text mt-2" v-if="errors.avatar_base64">{{ errors.avatar_base64 }}</div>
            </div>

            <div class="id-section">
              <div class="form-group" :class="{ 'has-error': errors.student_id }">
                <label>ລະຫັດນັກຮຽນ <span class="req">*</span></label>
                <div class="id-input-group">
                  <input type="text" v-model="studentForm.student_id" readonly placeholder="Auto ID">
                  <button v-if="!isEdit" type="button" @click="generateStudentId" class="refresh-id" title="ສ້າງລະຫັດໃໝ່">
                    <i class="fas fa-magic"></i> <span>ສ້າງລະຫັດ</span>
                  </button>
                </div>
                <div class="error-text" v-if="errors.student_id">{{ errors.student_id }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- ສ່ວນເບື້ອງຂວາ: ຂໍ້ມູນລາຍລະອຽດ -->
        <div class="form-main">
          <!-- Group 1: ຂໍ້ມູນສ່ວນຕົວ -->
          <div class="panel mb-4">
            <div class="panel-head">
              <h3><i class="fas fa-user-graduate"></i> ຂໍ້ມູນຊີວະປະຫວັດ (ພາສາລາວ)</h3>
            </div>
            <div class="panel-body">
            <div class="field-row">
              <div class="form-group" :class="{ 'has-error': errors.firstNameLao }">
                <label>ຊື່ <span class="req">*</span></label>
                <input type="text" v-model="studentForm.firstNameLao" @input="clearError('firstNameLao')" placeholder="ປ້ອນຊື່ນັກຮຽນ">
                <div class="error-text" v-if="errors.firstNameLao">{{ errors.firstNameLao }}</div>
              </div>
              <div class="form-group" :class="{ 'has-error': errors.familyNameLao }">
                <label>ນາມສະກຸນ <span class="req">*</span></label>
                <input type="text" v-model="studentForm.familyNameLao" @input="clearError('familyNameLao')" placeholder="ປ້ອນນາມສະກຸນ">
                <div class="error-text" v-if="errors.familyNameLao">{{ errors.familyNameLao }}</div>
              </div>
            </div>
            <div class="field-row">
              <div class="form-group" :class="{ 'has-error': errors.dob }">
                <label>ວັນເດືອນປີເກີດ <span class="req">*</span></label>
                <input type="text" v-model="dobText" @input="handleDobInput" placeholder="dd/mm/yyyy" inputmode="numeric" maxlength="10">
                <div class="error-text" v-if="errors.dob">{{ errors.dob }}</div>
              </div>
              <div class="form-group" :class="{ 'has-error': errors.gender }">
                <label>ເພດ <span class="req">*</span></label>
                <select v-model="studentForm.gender" @change="clearError('gender')">
                  <option value="ຊ">ຊາຍ</option>
                  <option value="ຍ">ຍິງ</option>
                </select>
                <div class="error-text" v-if="errors.gender">{{ errors.gender }}</div>
              </div>
            </div>
            <div class="field-row-3">
              <div class="form-group" :class="{ 'has-error': errors.Grade_Code }">
                <label>ຊັ້ນຮຽນ <span class="req">*</span></label>
                <select v-model="studentForm.Grade_Code" @change="clearError('Grade_Code')">
                  <option :value="null">-- ເລືອກຊັ້ນຮຽນ --</option>
                  <option v-for="item in classList" :key="item.value" :value="item.value">{{ item.text }}</option>
                </select>
                <div class="error-text" v-if="errors.Grade_Code">{{ errors.Grade_Code }}</div>
              </div>
              <div class="form-group">
                <label>ຫ້ອງຮຽນ</label>
                <select v-model="studentForm.room_no">
                  <option :value="null">-- ເລືອກຫ້ອງ --</option>
                  <option v-for="n in 20" :key="n" :value="n">ຫ້ອງ {{ n }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>ສົກຮຽນ</label>
                <input type="text" v-model="studentForm.accd_current">
              </div>
            </div>
            </div>
          </div>

          <!-- Group 2: ຂໍ້ມູນພາສາອັງກິດ & ທີ່ຢູ່ -->
          <div class="panel">
            <div class="panel-head">
              <h3><i class="fas fa-globe"></i> Additional Information (English)</h3>
            </div>
            <div class="panel-body">
            <div class="field-row">
              <div class="form-group">
                <label>First Name (EN)</label>
                <input type="text" v-model="studentForm.nameEnglish" placeholder="First Name">
              </div>
              <div class="form-group">
                <label>Family Name (EN)</label>
                <input type="text" v-model="studentForm.familyNameEnglish" placeholder="Family Name">
              </div>
            </div>
            
            <div class="field-row">
              <div class="form-group">
                <label>ແຂວງປັດຈຸບັນ</label>
                <div class="input-with-action pointer" @click="openLocationModal('province', 'cur')">
                  <input type="text" :value="locationNames.cur_province" readonly placeholder="ເລືອກແຂວງ">
                  <button type="button" class="btn-icon">
                    <i class="fas fa-map-marker-alt"></i>
                  </button>
                </div>
              </div>
              <div class="form-group">
                <label>ເມືອງປັດຈຸບັນ</label>
                <div class="input-with-action pointer" :class="{'disabled': !studentForm.cur_prov_id}" @click="openLocationModal('district', 'cur')">
                  <input type="text" :value="locationNames.cur_district" readonly placeholder="ເລືອກເມືອງ">
                  <button type="button" class="btn-icon">
                    <i class="fas fa-search"></i>
                  </button>
                </div>
              </div>
              <div class="form-group">
                <label>ຕາແສງປັດຈຸບັນ</label>
                <div class="input-with-action pointer" :class="{'disabled': !studentForm.cur_district_id}" @click="openLocationModal('commune', 'cur')">
                  <input type="text" :value="locationNames.cur_commune" readonly placeholder="ເລືອກຕາແສງ">
                  <button type="button" class="btn-icon">
                    <i class="fas fa-layer-group"></i>
                  </button>
                </div>
              </div>
              <div class="form-group">
                <label>ບ້ານປັດຈຸບັນ</label>
                <div class="input-with-action pointer" :class="{'disabled': !studentForm.cur_district_id}" @click="openLocationModal('village', 'cur')">
                  <input type="text" :value="locationNames.cur_village" readonly placeholder="ເລືອກບ້ານ">
                  <button type="button" class="btn-icon"><i class="fas fa-house-user"></i></button>
                </div>
              </div>
              
            </div>
            <div class="form-group">
              <label>ທີ່ຢູ່ລະອຽດ (ເຮືອນເລກທີ, ໜ່ວຍ...)</label>
              <textarea v-model="studentForm.cur_address" rows="2" placeholder="ປ້ອນທີ່ຢູ່ລະອຽດ..."></textarea>
            </div>
          </div>
          </div>

          <!-- Group 3: ທີ່ຢູ່ບ້ານເກີດ -->
          <div class="panel mt-4">
            <div class="panel-head">
              <h3><i class="fas fa-map-marked-alt"></i> ທີ່ຢູ່ບ້ານເກີດ</h3>
            </div>
            <div class="panel-body">
              <div class="field-row">
                <div class="form-group">
                  <label>ແຂວງເກີດ</label>
                  <div class="input-with-action pointer" @click="openLocationModal('province', 'b')">
                    <input type="text" :value="locationNames.b_province" readonly placeholder="ເລືອກແຂວງ">
                    <button type="button" class="btn-icon">
                      <i class="fas fa-map-marker-alt"></i>
                    </button>
                  </div>
                </div>
                <div class="form-group">
                  <label>ເມືອງເກີດ</label>
                  <div class="input-with-action pointer" :class="{'disabled': !studentForm.b_prov_id}" @click="openLocationModal('district', 'b')">
                    <input type="text" :value="locationNames.b_district" readonly placeholder="ເລືອກເມືອງ">
                    <button type="button" class="btn-icon">
                      <i class="fas fa-search"></i>
                    </button>
                  </div>
                </div>
                <div class="form-group">
                  <label>ຕາແສງເກີດ</label>
                  <div class="input-with-action pointer" :class="{'disabled': !studentForm.b_district_id}" @click="openLocationModal('commune', 'b')">
                    <input type="text" :value="locationNames.b_commune" readonly placeholder="ເລືອກຕາແສງ">
                    <button type="button" class="btn-icon">
                      <i class="fas fa-layer-group"></i>
                    </button>
                  </div>
                </div>
                <div class="form-group">
                  <label>ບ້ານເກີດ</label>
                  <div class="input-with-action pointer" :class="{'disabled': !studentForm.b_district_id}" @click="openLocationModal('village', 'b')">
                    <input type="text" :value="locationNames.b_village" readonly placeholder="ເລືອກບ້ານ">
                    <button type="button" class="btn-icon"><i class="fas fa-house-user"></i></button>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>ທີ່ຢູ່ລະອຽດ (ເຮືອນເລກທີ, ໜ່ວຍ...)</label>
                <textarea v-model="studentForm.b_address" rows="2" placeholder="ປ້ອນທີ່ຢູ່ລະອຽດ..."></textarea>
              </div>
            </div>
          </div>

          <!-- Group 4: ຂໍ້ມູນ EMIS/LESMIS -->
          <div class="panel mt-4">
            <div class="panel-head">
              <h3><i class="fas fa-clipboard-list"></i> ຂໍ້ມູນ EMIS / LESMIS</h3>
            </div>
            <div class="panel-body">
              <div class="field-row">
                <div class="form-group" :class="{ 'has-error': errors.enrollment_status }">
                  <label>ສະຖານະພາບການລົງທະບຽນ (Q.32) <span class="req">*</span></label>
                  <select v-model="studentForm.enrollment_status" @change="clearError('enrollment_status')">
                    <option :value="null">-- ເລືອກສະຖານະ --</option>
                    <option v-for="o in enrollmentStatusOptions" :key="o.value" :value="o.value">{{ o.text }}</option>
                  </select>
                  <div class="error-text" v-if="errors.enrollment_status">{{ errors.enrollment_status }}</div>
                </div>
                <div class="form-group" :class="{ 'has-error': errors.ethnicity_code }">
                  <label>ຊົນເຜົ່າ (Q.34) <span class="req">*</span></label>
                  <select v-model="studentForm.ethnicity_code" @change="clearError('ethnicity_code')">
                    <option :value="null">-- ເລືອກຊົນເຜົ່າ --</option>
                    <optgroup v-for="g in ethnicityGroups" :key="g.label" :label="g.label">
                      <option v-for="e in g.items" :key="e.value" :value="e.value">{{ e.value }} - {{ e.text }}</option>
                    </optgroup>
                  </select>
                  <div class="error-text" v-if="errors.ethnicity_code">{{ errors.ethnicity_code }}</div>
                </div>
              </div>
              <div class="field-row">
                <div class="form-group" :class="{ 'has-error': errors.disability }">
                  <label>ຄວາມພິການ (Q.35) <span class="req">*</span></label>
                  <select v-model="studentForm.disability" @change="clearError('disability')">
                    <option :value="null">-- ເລືອກ --</option>
                    <option v-for="d in disabilityOptions" :key="d.value" :value="d.value">{{ d.text }}</option>
                  </select>
                  <div class="error-text" v-if="errors.disability">{{ errors.disability }}</div>
                </div>
                <div class="form-group" v-if="studentForm.disability === 1" :class="{ 'has-error': errors.disability_type }">
                  <label>ປະເພດຄວາມພິການ (Q.36) <span class="req">*</span></label>
                  <select v-model="studentForm.disability_type" @change="clearError('disability_type')">
                    <option :value="null">-- ເລືອກປະເພດ --</option>
                    <option v-for="t in disabilityTypeOptions" :key="t.value" :value="t.value">{{ t.text }}</option>
                  </select>
                  <div class="error-text" v-if="errors.disability_type">{{ errors.disability_type }}</div>
                </div>
                <div class="form-group" v-else>
                  <label style="color:#94a3b8;">ປະເພດຄວາມພິການ (Q.36)</label>
                  <input type="text" disabled placeholder="ສະແດງເມື່ອ Q.35 = ມີ" style="background:#f8fafc;color:#94a3b8;">
                </div>
              </div>
            </div>
          </div>

          <!-- ປຸ່ມ Actions -->
          <div class="form-actions-wrapper mt-4">
            <button type="button" class="btn-cancel" @click="$router.back()">ຍົກເລີກ</button>
            <button type="submit" class="btn-save" :disabled="submitting">
              <i class="fas fa-save"></i> {{ submitting ? 'ກຳລັງບັນທຶກ...' : (isEdit ? 'ອັບເດດຂໍ້ມູນ' : 'ບັນທຶກຂໍ້ມູນນັກຮຽນ') }}
            </button>
          </div>
        </div>
      </div>
      </form>

    <!-- Modal ຄົ້ນຫາ ແລະ ເລືອກ -->
    <transition name="modal">
      <div v-if="showModal" class="modal-overlay" @mousedown.self="closeModal">
        <div class="custom-modal-card" role="dialog" aria-modal="true">
          <div class="custom-modal-header">
            <h3>{{ modalTitle }}</h3>
            <button @click="closeModal" class="close-btn">&times;</button>
          </div>
          <div class="custom-modal-search">
            <div class="input-container">
              <i class="fas fa-search search-icon"></i>
              <input 
                type="text" 
                v-model="modalSearchQuery" 
                placeholder="ພິມເພື່ອຄົ້ນຫາ..."
                ref="modalSearchInput"
              >
            </div>
          </div>
          <div class="custom-modal-body">
            
            <div v-if="modalLoading" class="loading-state">
              <i class="fas fa-spinner fa-spin"></i> ກຳລັງໂຫຼດ...
            </div>
            <template v-else>
              <div 
                v-for="item in filteredModalItems" 
                :key="item.id" 
                class="list-item"
                @click="selectModalItem(item)"
              >
                <span class="item-name">{{ item.name }}</span>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div v-if="filteredModalItems.length === 0" class="empty-state">
                ບໍ່ພົບຂໍ້ມູນ
              </div>
            </template>
          </div>
          <div class="custom-modal-footer">
            <button type="button" class="btn-modal-cancel" @click="closeModal">ຍົກເລີກ</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import api from '@/utils/api';

const generateStudentIDG = (data) => {
  const { ISO_Code = 'LA', Year_Entry_Code = '', Province_Code = '', District_Code = '', Serial_ID = '' } = data;
  // Format: ISO-ProvinceDistrict(4)-Year(2)-Serial(7)-CheckDigit
  // Example: LA-1301-25-0014679-0
  const provStr = String(Province_Code).padStart(2, '0');
  const distStr = String(District_Code).padStart(2, '0');
  const yearStr = String(Year_Entry_Code).padStart(2, '0');
  const serialStr = String(Serial_ID || '').padStart(7, '0');
  const baseId = `${ISO_Code}-${provStr}${distStr}-${yearStr}-${serialStr}`;

  // Calculate Check Digit (Luhn Mod 10) on the numeric portion only
  const numericPart = baseId.replace(/\D/g, '');
  const checkDigit = calculateLuhn(numericPart);
  return `${baseId}-${checkDigit}`;
};

function calculateLuhn(numberStr) { // Helper function for Luhn algorithm
  let sum = 0;
  // Luhn doubles every second digit from the right (i.e., start with false)
  let shouldDouble = false;
  for (let i = numberStr.length - 1; i >= 0; i--) {
    let digit = parseInt(numberStr.charAt(i), 10);
    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
    shouldDouble = !shouldDouble;
  }
  return (10 - (sum % 10)) % 10;
}

export default {
  name: 'StudentNewPage',
  data() {
    return {
      user: null,
      isEdit: false,
      submitting: false,
      dobText: '',
      studentForm: {
                "school_id": null,
                "student_id": "",
                "firstNameLao": "",
                "familyNameLao": "",
                "nameEnglish": "",
                "familyNameEnglish": "",
                "dob": "",
                "gender": "ຊ", // Default to 'ຊາຍ'
                "accd_current": "2025-2026", // Default academic year
                "room_no": null,
                "b_district_id": null, // Default to null for select
                "b_prov_id": null, // Default to null for select
                "b_village": "",
                "b_commune": "",
                "Grade_Code": null,
                "b_address": "",
                "cur_prov_id": "",
                "cur_district_id": "",
                "cur_village": "",
                "cur_commune": "",
                "cur_address": "",
                "home_no": "",
                "group_no": "",
                "road": "",
                "note_no": "",
                "issue_by": "",
                "issur_date": "",
                "note_detail": "",
                "type_student_id": "",
                "grade_last": "",
                "grade_befor": "",
                "avatar_base64": null,
                "enrollment_status": null,
                "ethnicity_code": null,
                "disability": null,
                "disability_type": null,
      },
      classList: [], // ລາຍການຊັ້ນຮຽນຈາກ API
      enrollmentStatusOptions: [
        { value: 1, text: '1 - ນັກຮຽນໃໝ່ (ບໍ່ທັນໄດ້ລົງທະບຽນຢູ່ໃສ)' },
        { value: 2, text: '2 - ເສັງໄດ້/ເລື່ອນຂັ້ນ (ພາຍໃນລະດັບ)' },
        { value: 3, text: '3 - ເສັງໄດ້/ເລື່ອນຊັ້ນ (ຂ້າມລະດັບ)' },
        { value: 4, text: '4 - ປະລະ ແລ້ວມາເຂົ້າຮຽນຄືນ' },
        { value: 5, text: '5 - ຍ້າຍມາຈາກໂຮງຮຽນອື່ນ' },
      ],
      disabilityOptions: [
        { value: 1, text: 'ມີ' },
        { value: 2, text: 'ບໍ່ມີ' },
        { value: 3, text: 'ບໍ່ແນ່ໃຈ' },
      ],
      disabilityTypeOptions: [
        { value: 1, text: 'ດ້ານການໄດ້ຍິນ ແລະ ການປາກເວົ້າ' },
        { value: 2, text: 'ດ້ານການເບິ່ງເຫັນ' },
        { value: 3, text: 'ດ້ານຮ່າງກາຍ' },
        { value: 4, text: 'ດ້ານສະຕິປັນຍາ' },
        { value: 5, text: 'ດ້ານຄວາມຈື່ຈຳ' },
        { value: 6, text: 'ດ້ານອື່ນໆ (ຊ້ຳຊ້ອນ)' },
      ],
      ethnicityGroups: [
        { label: 'ລາວໄຕ', items: [
          {value:1,text:'ລາວ'},{value:2,text:'ໄຕ'},{value:3,text:'ຜູ້ໄທ'},{value:4,text:'ລື້'},
          {value:5,text:'ຍວນ'},{value:6,text:'ຢັ້ງ'},{value:7,text:'ແຊກ'},{value:8,text:'ໄທເໜືອ'},
        ]},
        { label: 'ມອນຂະແມ', items: [
          {value:9,text:'ກຶມມຸ'},{value:10,text:'ໄປຣ'},{value:11,text:'ຊີງມູນ'},{value:12,text:'ຜ້ອງ'},
          {value:13,text:'ແທ່ນ'},{value:14,text:'ເອີດູ'},{value:15,text:'ບິດ'},{value:16,text:'ລະເມດ'},
          {value:17,text:'ສາມຕ່າວ'},{value:18,text:'ກະຕາງ'},{value:19,text:'ມະກອງ'},{value:20,text:'ຕຣີ'},
          {value:21,text:'ຢຣູ'},{value:22,text:'ຕຣຽງ'},{value:23,text:'ຕະໂອ້ຍ'},{value:24,text:'ແຢະ'},
          {value:25,text:'ເບຣົາ'},{value:26,text:'ກະຕູ'},{value:27,text:'ຮາຣັກ'},{value:28,text:'ໂອຍ'},
          {value:29,text:'ກຣຽງ'},{value:30,text:'ເຈັງ'},{value:31,text:'ສະດາງ'},{value:32,text:'ຊ່ວຍ'},
          {value:33,text:'ຍະເຫີນ'},{value:34,text:'ລະວີ'},{value:35,text:'ປະໂກະ'},{value:36,text:'ຂະແມ'},
          {value:37,text:'ຕຸ້ມ'},{value:38,text:'ງວນ'},{value:39,text:'ມ້ອຍ'},{value:40,text:'ກຣີ'},
        ]},
        { label: 'ມົ້ງ-ອີວມຽນ', items: [
          {value:41,text:'ມົ້ງ'},{value:42,text:'ອີ້ວມຽນ'},
        ]},
        { label: 'ຈີນທິເບດ', items: [
          {value:43,text:'ອາຄາ'},{value:44,text:'ພູນ້ອຍ'},{value:45,text:'ລາຫູ'},{value:46,text:'ສີລາ'},
          {value:47,text:'ຮາຢີ'},{value:48,text:'ໂລໂລ'},{value:49,text:'ຫໍ້'},
        ]},
        { label: 'ອື່ນໆ', items: [
          {value:50,text:'ອື່ນໆ (ໄດ້ຮັບສັນຊາດລາວ)'},{value:51,text:'ຕ່າງດ້າວ'},
        ]},
      ],
      errors: {},
      // Modal States
      showModal: false,
      modalTitle: '',
      modalType: '', // 'province', 'district', 'village'
      modalTarget: '', // 'cur', 'b'
      modalSearchQuery: '',
      modalLoading: false,
      modalItems: [],
      locationNames: {
        cur_province: '',
        cur_district: '',
        cur_commune: '',
        cur_village: '',
        b_province: '',
        b_district: '',
        b_commune: '',
        b_village: ''
      }
    }
  },
  mounted() {
     let login = localStorage.getItem("user-info");
      this.user = JSON.parse(login);
        // ກວດສອບສິດການຈັດການ (Manage - Bit 1) ສໍາລັບໂມດູນ staff
  //   alert(this.hasBit('student-new', 1))
  // if (!this.hasBit( 'student-new', 1)) {
  //     this.$router.push({ name: 'Forbidden' });
  //    return;
  //  }
    // ກວດສອບວ່າເປັນການແກ້ໄຂຫຼືບໍ່ ໂດຍເບິ່ງຈາກ ID ໃນ Route
    const studentId = this.$route.params.id;
    this.fetchClassList(); // ໂຫຼດລາຍຊື່ຊັ້ນຮຽນ
    if (studentId) {
      this.isEdit = true;
      this.fetchStudentData(studentId);
      this.populateLocationNames(); // Populate names after fetching data
    } else {
      this.generateStudentId();
    }
    // ເພີ່ມ event listener ສຳລັບປຸ່ມ Escape
    document.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
    this.enableScroll();
  },
  computed: {
    filteredModalItems() {
      if (!this.modalSearchQuery) return this.modalItems;
      const q = this.modalSearchQuery.toLowerCase();
      return this.modalItems.filter(i => i.name.toLowerCase().includes(q));
    }
  },
  methods: {
    handleKeyDown(e) {
      if (e.key === 'Escape' && this.showModal) {
        this.closeModal();
      }
    },
    async fetchClassList() {
      try {
        const response = await api.get('/getItems/class_list/class_desc_lao/id');
        // API ຈະສົ່ງຂໍ້ມູນມາເປັນ [{ text: 'ມ1', value: '1' }, ...]
        this.classList = response.data;
      } catch (error) {
        console.error('Error fetching class list:', error);
      }
    },
    async fetchStudentData(id) {
      try {
        const response = await api.get(`/get/students/${id}`);
        if (response.data.code === 1) {
          this.studentForm = response.data.rows;
          this.dobText = this.formatDobForDisplay(this.studentForm.dob);
          this.populateLocationNames(); // Call to populate display names
        } else {
          alert('ບໍ່ສາມາດໂຫຼດຂໍ້ມູນນັກຮຽນໄດ້');
          this.$router.back();
        }
      } catch (error) {
        console.error('Error fetching student:', error);
        alert('ເກີດຂໍ້ຜິດພາດໃນການເຊື່ອມຕໍ່');
      }
    },
    async generateStudentId() {
      try {
        // ລະຫັດອີງໃສ່ ແຂວງ+ເມືອງ ຂອງໂຮງຮຽນທີ່ login ເຂົ້າມາ ແລະ ປີປັດຈຸບັນ (ຈາກ dd/mm/yyyy)
        // ໝາຍເຫດ: district_id ບາງໂຮງຮຽນອາດຖືກເກັບເປັນລະຫັດລວມ 4 ຫຼັກ (ແຂວງ+ເມືອງ) ຢູ່ແລ້ວ,
        // ຈຶ່ງໃຊ້ພຽງ 2 ຫຼັກສຸດທ້າຍ ເປັນລະຫັດເມືອງ ເພື່ອບໍ່ໃຫ້ຊ້ຳລະຫັດແຂວງ
        const provId = String(this.user?.prov_id || '').padStart(2, '0').slice(-2);
        const districtId = String(this.user?.district_id || '').padStart(2, '0').slice(-2);
        const yearCode = String(new Date().getFullYear()).slice(-2);
        const prefix = `LA-${provId}${districtId}-${yearCode}-`;

        // ຄົ້ນຫານັກຮຽນລ້າສຸດທີ່ຂຶ້ນຕົ້ນດ້ວຍ prefix ດຽວກັນ (ແຂວງ+ເມືອງ+ປີ) ເພື່ອສ້າງລຳດັບຕໍ່ເນື່ອງ
        const response = await api.get('/students', {
          params: { limit: 1, sort: '-student_id', student_id_prefix: prefix }
        });

        let nextSerial = 1;
        if (response.data.code === 1 && response.data.rows && response.data.rows.length > 0) {
          const lastId = response.data.rows[0].student_id;
          // ດຶງເອົາລຳດັບ 7 ຫຼັກ ຈາກລະຫັດເກົ່າ (ຕົວຢ່າງ LA-1301-25-0014679-0 -> 0014679)
          const match = lastId.match(/-(\d{7})-\d$/);
          if (match) {
            nextSerial = parseInt(match[1], 10) + 1;
          }
        }

        this.studentForm.student_id = generateStudentIDG({
          ISO_Code: 'LA',
          Year_Entry_Code: yearCode,
          Province_Code: provId,
          District_Code: districtId,
          Serial_ID: nextSerial,
        });
        this.clearError('student_id');
      } catch (error) {
        console.error('Gen ID Error:', error);
      }
    },
    validateForm() {
      const newErrors = {};
      // ຂໍ້ມູນພື້ນຖານ
      if (!this.studentForm.student_id) newErrors.student_id = 'ກະລຸນາປ້ອນລະຫັດນັກຮຽນ';
      if (!this.studentForm.firstNameLao) newErrors.firstNameLao = 'ກະລຸນາປ້ອນຊື່';
      if (!this.studentForm.familyNameLao) newErrors.familyNameLao = 'ກະລຸນາປ້ອນນາມສະກຸນ';
      if (!this.studentForm.dob) newErrors.dob = 'ກະລຸນາເລືອກວັນເກີດ';
      if (!this.studentForm.gender) newErrors.gender = 'ກະລຸນາເລືອກເພດ';
      if (!this.studentForm.Grade_Code) newErrors.Grade_Code = 'ກະລຸນາປ້ອນຊັ້ນຮຽນ';
      // EMIS fields (Q.32, Q.34, Q.35, Q.36)
      if (!this.studentForm.enrollment_status) newErrors.enrollment_status = 'ກະລຸນາເລືອກສະຖານະລົງທະບຽນ (EMIS Q.32)';
      if (!this.studentForm.ethnicity_code) newErrors.ethnicity_code = 'ກະລຸນາເລືອກຊົນເຜົ່າ (EMIS Q.34)';
      if (!this.studentForm.disability) newErrors.disability = 'ກະລຸນາລະບຸຄວາມພິການ (EMIS Q.35)';
      if (this.studentForm.disability === 1 && !this.studentForm.disability_type) {
        newErrors.disability_type = 'ກະລຸນາລະບຸປະເພດຄວາມພິການ (EMIS Q.36)';
      }
      this.errors = newErrors;
      return Object.keys(newErrors).length === 0;
    },
    clearError(field) {
      if (this.errors[field]) {
        this.$set(this.errors, field, null);
      }
    },
    formatDobForDisplay(iso) {
      if (!iso) return '';
      const [y, m, d] = String(iso).split('-');
      if (!y || !m || !d) return '';
      return `${d}/${m}/${y}`;
    },
    handleDobInput() {
      const digits = this.dobText.replace(/\D/g, '').slice(0, 8);
      let formatted = digits;
      if (digits.length > 4) formatted = `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4, 8)}`;
      else if (digits.length > 2) formatted = `${digits.slice(0, 2)}/${digits.slice(2, 4)}`;
      this.dobText = formatted;

      if (digits.length === 8) {
        const day = digits.slice(0, 2), month = digits.slice(2, 4), year = digits.slice(4, 8);
        this.studentForm.dob = `${year}-${month}-${day}`;
        this.clearError('dob');
      } else {
        this.studentForm.dob = '';
      }
    },
    async handleSubmit() {
      if (!this.validateForm()) {
        return;
      }

      this.submitting = true;
      try {
        let response;
        if (this.isEdit) {
          // ສົມມຸດວ່າ Endpoint ແກ້ໄຂແມ່ນ /updateOne ຫຼື PUT /students/:id
          response = await api.put(`/students/${this.$route.params.id}`, {
            items: this.studentForm,
            table: 'students'
          });
        } else {
          response = await api.post('/insertOne', { 
            items: this.studentForm, 
            table: 'students' 
          });
        }

        if (response.data.code === 1) {
          alert('ບັນທຶກຂໍ້ມູນນັກຮຽນສຳເລັດ!');
          this.$router.push('/home/students/list');
        } else {
          alert(response.data.desc || 'ເກີດຂໍ້ຜິດພາດ');
        }
      } catch (error) {
        console.error('Submit error:', error);
        alert('ບໍ່ສາມາດເຊື່ອມຕໍ່ກັບ API');
      } finally {
        this.submitting = false;
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        // ກວດສອບຂະໜາດໄຟລ໌ (ຕົວຢ່າງ: ບໍ່ເກີນ 2MB)
        if (file.size > 2 * 1024 * 1024) {
          this.$set(this.errors, 'avatar_base64', 'ຂະໜາດຮູບພາບຕ້ອງບໍ່ເກີນ 2MB');
          this.studentForm.avatar_base64 = null;
          event.target.value = ''; // ລ້າງໄຟລ໌ທີ່ເລືອກ
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          this.studentForm.avatar_base64 = e.target.result;
          this.clearError('avatar_base64');
        };
        reader.readAsDataURL(file);
      } else {
        this.studentForm.avatar_base64 = null;
      }
    },
    removeAvatar() {
      this.studentForm.avatar_base64 = null;
      // ຖ້າຕ້ອງການລ້າງໄຟລ໌ໃນ input ດ້ວຍ, ຕ້ອງເຂົ້າເຖິງ DOM ໂດຍກົງ
      const fileInput = this.$el.querySelector('input[type="file"]');
      if (fileInput) fileInput.value = '';
    },
    async populateLocationNames() {
      // Populate current address
      if (this.studentForm.cur_prov_id) {
        const prov = await api.get(`/getItems/province/prov_name/prov_id?id=${this.studentForm.cur_prov_id}`);
        if (prov.data && prov.data.length > 0) this.locationNames.cur_province = prov.data[0].text;
      }
      if (this.studentForm.cur_district_id) {
        const dist = await api.get(`/getItemsCondition/district/district_name_lao/district_id/prov_id/${this.studentForm.cur_prov_id}?id=${this.studentForm.cur_district_id}`);
        if (dist.data && dist.data.length > 0) this.locationNames.cur_district = dist.data[0].text;
      }
      if (this.studentForm.cur_commune) { // Assuming commune is stored as name
        this.locationNames.cur_commune = this.studentForm.cur_commune;
      }
      if (this.studentForm.cur_village) { // Assuming village is stored as name
        this.locationNames.cur_village = this.studentForm.cur_village;
      }

      // Populate birth address
      if (this.studentForm.b_prov_id) {
        const prov = await api.get(`/getItems/province/prov_name/prov_id?id=${this.studentForm.b_prov_id}`);
        if (prov.data && prov.data.length > 0) this.locationNames.b_province = prov.data[0].text;
      }
      if (this.studentForm.b_district_id) {
        const dist = await api.get(`/getItemsCondition/district/district_name_lao/district_id/prov_id/${this.studentForm.b_prov_id}?id=${this.studentForm.b_district_id}`);
        if (dist.data && dist.data.length > 0) this.locationNames.b_district = dist.data[0].text;
      }
      if (this.studentForm.b_commune) { // Assuming commune is stored as name
        this.locationNames.b_commune = this.studentForm.b_commune;
      }
      if (this.studentForm.b_village) { // Assuming village is stored as name
        this.locationNames.b_village = this.studentForm.b_village;
      }
    },
    // Location Picker Methods
    async openLocationModal(type, target) {
      if (type === 'district' || type === 'commune' || type === 'village') {
        const parentId = target === 'cur' ? this.studentForm.cur_prov_id : this.studentForm.b_prov_id;
        if (!parentId) {
          alert('ກະລຸນາເລືອກແຂວງກ່ອນ');
          return;
        }
        if (type === 'commune' || type === 'village') {
          const distId = target === 'cur' ? this.studentForm.cur_district_id : this.studentForm.b_district_id;
          if (!distId) {
            alert('ກະລຸນາເລືອກເມືອງກ່ອນ');
            return;
          }
        }
      }

      this.disableScroll();

      this.modalType = type;
      this.modalTarget = target;
      this.modalSearchQuery = '';
      this.showModal = true;
      this.modalLoading = true;
      this.modalItems = [];
      
      this.modalTitle = type === 'province' ? 'ເລືອກແຂວງ' : 
                        (type === 'district' ? 'ເລືອກເມືອງ' : 
                        (type === 'commune' ? 'ເລືອກຕາແສງ' : 'ເລືອກບ້ານ'));

      try {
        let url = '';
        let params = {};

        if (type === 'province') {
          url = '/getItems/province/prov_name/prov_id';
        } else if (type === 'district') {
          const provId = target === 'cur' ? this.studentForm.cur_prov_id : this.studentForm.b_prov_id;
          url = `/getItemsCondition/district/district_name_lao/district_id/prov_id/${provId}`;
          params.prov_id = provId;
        } else if (type === 'commune') {
          const distId = target === 'cur' ? this.studentForm.cur_district_id : this.studentForm.b_district_id;
          url = `/getItemsCondition/commune/commune_name/commune_id/district_id/${distId}`;
          params.district_id = distId;
        } else if (type === 'village') {
          const distId = target === 'cur' ? this.studentForm.cur_district_id : this.studentForm.b_district_id;
          url = `/getItemsCondition/village/village_name/village_id/district_id/${distId}`;
          params.district_id = distId;
        }

        const response = await api.get(url, { params });
      //  if (response.data.code === 1) {
          this.modalItems = response.data.map(item => ({ // Assuming response.data is an array of objects
            id: item.value || item.prov_id || item.district_id || item.commune_id || item.village_id,
            name: item.text || item.prov_name || item.district_name_lao || item.commune_name || item.village_name
          }));
      //  }
      } catch (error) {
        console.error('Fetch location error:', error);
      } finally {
        this.modalLoading = false;
        this.$nextTick(() => {
          if (this.$refs.modalSearchInput) this.$refs.modalSearchInput.focus();
        });
      }
    },
    selectModalItem(item) {
      const targetKey = `${this.modalTarget}_${this.modalType}`; 
      this.locationNames[targetKey] = item.name;

      if (this.modalType === 'province') {
        if (this.modalTarget === 'cur') {
          this.studentForm.cur_prov_id = item.id;
          this.studentForm.cur_district_id = null;
          this.studentForm.cur_commune = '';
          this.studentForm.cur_village = '';
          this.locationNames.cur_district = '';
          this.locationNames.cur_commune = '';
          this.locationNames.cur_village = '';
        } else {
          this.studentForm.b_prov_id = item.id;
          this.studentForm.b_district_id = null;
          this.studentForm.b_commune = '';
          this.studentForm.b_village = '';
          this.locationNames.b_district = '';
          this.locationNames.b_commune = '';
          this.locationNames.b_village = '';
        }
      } else if (this.modalType === 'district') {
        if (this.modalTarget === 'cur') {
          this.studentForm.cur_district_id = item.id;
          this.studentForm.cur_commune = '';
          this.studentForm.cur_village = '';
          this.locationNames.cur_commune = '';
          this.locationNames.cur_village = '';
        } else {
          this.studentForm.b_district_id = item.id;
          this.studentForm.b_commune = '';
          this.studentForm.b_village = '';
          this.locationNames.b_commune = '';
          this.locationNames.b_village = '';
        }
      } else if (this.modalType === 'commune') {
        if (this.modalTarget === 'cur') {
          this.studentForm.cur_commune = item.name;
          this.studentForm.cur_village = '';
          this.locationNames.cur_village = '';
        } else {
          this.studentForm.b_commune = item.name;
          this.studentForm.b_village = '';
          this.locationNames.b_village = '';
        }
      } else if (this.modalType === 'village') {
        if (this.modalTarget === 'cur') {
          this.studentForm.cur_village = item.name;
        } else {
          this.studentForm.b_village = item.name;
        }
      }
      this.closeModal();
    },
    closeModal() {
      this.showModal = false;
      this.modalSearchQuery = '';
      this.enableScroll();
    },
    disableScroll() {
      document.body.style.overflow = 'hidden';
    },
    enableScroll() {
      document.body.style.overflow = '';
    }
  }
}
</script>

<style scoped>
.student-form-container { animation: fadeIn 0.3s ease; }
.form-layout { display: grid; grid-template-columns: 300px 1fr; gap: 24px; margin-top: 10px; align-items: start; }

.avatar-panel { padding: 30px 20px; text-align: center; }
.avatar-wrapper { margin-bottom: 20px; }
.avatar-view { width: 160px; height: 160px; border-radius: 50%; border: 4px solid var(--lao-light); margin: 0 auto 15px; position: relative; background: #f8fafc; overflow: hidden; }
.avatar-view img { width: 100%; height: 100%; object-fit: cover; }
.avatar-view img.is-empty { padding: 35px; opacity: 0.2; }
.remove-avatar { position: absolute; top: 5px; right: 5px; background: var(--danger); color: white; border: none; border-radius: 50%; width: 26px; height: 26px; cursor: pointer; font-weight: bold; }
.upload-label { background: var(--gold); color: white; padding: 8px 20px; border-radius: 20px; font-size: 13px; font-weight: 600; cursor: pointer; transition: 0.2s; }
.upload-label:hover { background: #b08520; transform: translateY(-1px); }

.id-section { border-top: 1px solid var(--border); padding-top: 20px; text-align: left; }
.id-input-group { display: flex; align-items: center; background: #f1f5f9; border-radius: 8px; overflow: hidden; border: 1px solid var(--border); }
.id-input-group input { 
  flex: 1;
  background: transparent; 
  border: none !important; 
  font-weight: 700; 
  color: var(--lao); 
  font-family: 'IBM Plex Mono', monospace; 
  padding-left: 15px;
}
.refresh-id { 
  background: var(--lao-light); 
  border: none; 
  color: var(--lao); 
  padding: 10px 15px; 
  cursor: pointer; 
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 13px;
  transition: 0.2s;
  white-space: nowrap;
}
.refresh-id:hover { background: var(--lao); color: white; }
.refresh-id i { font-size: 14px; }

/* ເພີ່ມ Style ສໍາລັບສ່ວນເລືອກທີ່ຢູ່ */
.input-with-action {
  position: relative;
  display: flex;
  align-items: center;
}
.input-with-action input {
  padding-right: 40px !important; /* ເວັ້ນບ່ອນໃຫ້ Icon */
  cursor: pointer;
}
.btn-icon {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  color: var(--lao);
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 16px;
}
.input-with-action.disabled {
  opacity: 0.6;
  pointer-events: none;
  background: #f8fafc;
  border-radius: 8px;
}
.pointer { cursor: pointer; }

.field-row { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
.field-row-3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 20px; }
.form-group { margin-bottom: 20px; }
.form-group label { display: block; font-size: 13px; color: var(--text2); margin-bottom: 8px; font-weight: 600; }
.req { color: var(--danger); }
.form-group input, .form-group select, .form-group textarea { 
  width: 100%; padding: 10px; border: 1px solid var(--border); border-radius: 8px; font-size: 14px; transition: all 0.2s;
}
.form-group input:focus { outline: none; border-color: var(--lao); box-shadow: 0 0 0 3px var(--lao-light); }

.form-group.has-error input, .form-group.has-error select {
  border-color: var(--danger);
  background-color: #fffafa;
}
.error-text {
  color: var(--danger);
  font-size: 12px;
  margin-top: 5px;
}

.form-actions-wrapper { display: flex; justify-content: flex-end; gap: 12px; padding-top: 20px; border-top: 1px solid var(--border); }
.btn-save { background: var(--lao); color: white; border: none; padding: 12px 30px; border-radius: 8px; cursor: pointer; font-weight: 600; font-size: 14px; transition: 0.2s; }
.btn-save:hover { background: var(--lao-mid); box-shadow: 0 4px 12px rgba(0,63,138,0.2); }
.btn-save:disabled { opacity: 0.6; cursor: not-allowed; }
.btn-cancel { background: #e2e8f0; color: var(--text2); border: none; padding: 12px 25px; border-radius: 8px; cursor: pointer; font-weight: 600; }

@media (max-width: 900px) { 
  .form-layout { grid-template-columns: 1fr; }
  .form-sidebar { position: static; width: 100%; }
  .avatar-view { width: 140px; height: 140px; }
  .field-row { grid-template-columns: 1fr; gap: 0; }
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}



/* --- Custom Modal Styling --- */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  padding: 20px;
}

.custom-modal-card {
  background: white;
  width: 100%;
  max-width: 480px;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow: hidden;
  animation: modalPop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.custom-modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.custom-modal-header h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--lao);
}

.close-btn {
  background: #f1f5f9;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #64748b;
  font-size: 20px;
  transition: 0.2s;
}

.close-btn:hover { background: #e2e8f0; color: #0f172a; }

.custom-modal-search { padding: 16px 24px; background: #f8fafc; border-bottom: 1px solid #f1f5f9; }
.custom-modal-search .input-container { position: relative; }
.custom-modal-search i { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: #94a3b8; }
.custom-modal-search input { 
  width: 100%; padding: 10px 10px 10px 40px; border: 1px solid #e2e8f0; border-radius: 10px; font-size: 14px; outline: none; transition: 0.2s;
}
.custom-modal-search input:focus { border-color: var(--lao); box-shadow: 0 0 0 3px rgba(0, 63, 138, 0.1); }

.custom-modal-body { flex: 1; overflow-y: auto; padding: 8px 0; }

.list-item {
  padding: 12px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s;
}

.list-item:hover { background: #f0f7ff; }
.list-item .item-name { font-size: 15px; color: #334155; }
.list-item i { font-size: 12px; color: #cbd5e1; }

.loading-state, .empty-state { padding: 40px; text-align: center; color: #94a3b8; font-size: 14px; }
.loading-state i { margin-bottom: 10px; font-size: 24px; display: block; }

.custom-modal-footer { padding: 16px 24px; border-top: 1px solid #f1f5f9; display: flex; justify-content: flex-end; }
.btn-modal-cancel { 
  background: white; border: 1px solid #e2e8f0; padding: 8px 20px; border-radius: 8px; font-weight: 600; color: #64748b; cursor: pointer; transition: 0.2s;
}
.btn-modal-cancel:hover { background: #f8fafc; color: #0f172a; }

/* Transitions */
.modal-enter-active, .modal-leave-active { transition: opacity 0.25s ease; }
.modal-enter, .modal-leave-to { opacity: 0; }

@keyframes modalPop {
  from { opacity: 0; transform: scale(0.95) translateY(-10px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

</style>